<template>
  <div class="vidoe-box">
    <video id="phone-video-player_html5_api" class="phone-video-player-html5-api"
      preload="auto" controls="true"
      x5-playsinline="" playsinline="" webkit-playsinline=""
      poster="https://mediakit.enabot.com/eboX/img/mobile/phone_video_home.png"
      src="https://mediakit.enabot.com/eboX/video/EBOXweb.mp4">
      <!-- <source
        src="https://jvod.300hu.com/vod/product/af576681-08b9-4291-966a-4ce33fedbc01/5c45d5888ba94eada0f1aba6842ba13f.mp4?source=2&h265=h265/113074/2bf7a0e1281b4123885b8b54065b7623.mp4"
        type="video/mp4">
      <p class="vjs-no-js"> 您的浏览器不支持 HTML 5 Video 标签，请升级浏览器。</p> -->
    </video>
    <img class="phone-videoIcon" src="https://mediakit.enabot.com/eboX/img/mobile/phone_video_play.png" alt="" @click="phonePlayFn" v-if="phonetype">
  </div>
</template>

<script>
export default {
  data() {
    return {
      phonetype:true,
      phonePlayer:null
    }
  },
  mounted() {
    this.phonePlayer = document.getElementById("phone-video-player_html5_api");
    // this.phonePlayer.pause()
    //该视频播放是否已结束
    this.phonePlayer.addEventListener('ended', this.handleEnded, false)
    this.phonePlayer.addEventListener('play', this.handlePlay, false)
    this.phonePlayer.addEventListener('pause', this.handlePause, false)
  },
  methods: {
    phonePlayFn() {
      this.phonetype = false
      this.$nextTick(() => {
        this.phonePlayer.play();
        if(window.gtag){
          window.gtag('event', 'click_play_button', {
            'event_category': 'button',
            'event_label': '点击按钮播放视频次数',
          });
        }
      })
    },
    handleEnded() {
      this.phonetype = true
      this.phonePlayer.load()
    },
    handlePlay() {
      this.phonetype = false
      this.phonePlayer.play()
      if(window.gtag){
        window.gtag('event', 'click_native_play', {
          'event_category': 'play',
          'event_label': '视频播放次数',
        });
      }
    },
    handlePause() {
      this.phonetype = true
      this.phonePlayer.pause()
    }
  },
}
</script>

<style lang="scss">
.vidoe-box{
  position: relative;
  width: 100%;
  min-height: 12rem;
  
  img{
    width: 100%;
  }
  .phone-video-player-html5-api{
    width: 100%;
    height: auto;
    min-height: 12rem;
  }
  .phone-videoIcon{
    position: absolute;
    background: rgba(255, 255, 255, 1);
    border-radius: 50%;
    width: 86px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    cursor: pointer;
    z-index: 1;
  }
}
</style>